import { createSagas } from "redux-box";
import { call, put } from "redux-saga/effects";
import swal from "sweetalert2";
import MiscApi from "@s/api/misc";

const getErrorMessage = (err) => {
  var responseMessage =
    err &&
    err.response &&
    err.response.data &&
    err.response.data.message;

  return (
    responseMessage ||
    (err && err.error_message) ||
    (err && err.message) ||
    "Something went wrong."
  );
};

export default createSagas({
  REQUEST_DOCUMENT_FILE_LIST: function*({ page }) {
    yield put({
      type: "SET_DOCUMENT_FILE_LIST_LOADING",
      value: true,
    });

    try {
      const res = yield call(MiscApi.getAdminDocumentFiles, page || 0);

      yield put({
        type: "SET_DOCUMENT_FILE_LIST",
        uploads: (res && res.result) || [],
        hasMore: !!(res && res.has_next),
        nextPage: (res && res.next_page) || 0,
      });
    } catch (err) {
      const message = getErrorMessage(err);
      yield put({
        type: "SET_DOCUMENT_FILE_ERROR",
        value: message,
      });
      swal("Oops!", message, "error");
    } finally {
      yield put({
        type: "SET_DOCUMENT_FILE_LIST_LOADING",
        value: false,
      });
    }
  },

  REQUEST_CONCAT_DOCUMENT_FILE_LIST: function*({ page }) {
    try {
      const res = yield call(MiscApi.getAdminDocumentFiles, page || 0);

      yield put({
        type: "CONCAT_DOCUMENT_FILE_LIST",
        uploads: (res && res.result) || [],
        hasMore: !!(res && res.has_next),
        nextPage: (res && res.next_page) || 0,
      });
    } catch (err) {
      const message = getErrorMessage(err);
      yield put({
        type: "SET_DOCUMENT_FILE_ERROR",
        value: message,
      });
      swal("Oops!", message, "error");
    }
  },

  CREATE_DOCUMENT_FILE: function*({ data }) {
    yield put({
      type: "SET_DOCUMENT_FILE_SUBMITTING",
      value: true,
    });
    yield put({
      type: "SET_DOCUMENT_FILE_ERROR",
      value: "",
    });

    try {
      yield call(MiscApi.createAdminDocumentFile, data);

      yield put({
        type: "REQUEST_DOCUMENT_FILE_LIST",
        page: 0,
      });
      yield put({
        type: "HIDE_MODAL",
      });
      yield put({
        type: "CLEAR_DOCUMENT_FILE_FORM_STATE",
      });
      swal("Done", "Document created successfully", "success");
    } catch (err) {
      const message = getErrorMessage(err);
      yield put({
        type: "SET_DOCUMENT_FILE_ERROR",
        value: message,
      });
    } finally {
      yield put({
        type: "SET_DOCUMENT_FILE_SUBMITTING",
        value: false,
      });
    }
  },

  UPDATE_DOCUMENT_FILE: function*({ data }) {
    yield put({
      type: "SET_DOCUMENT_FILE_SUBMITTING",
      value: true,
    });
    yield put({
      type: "SET_DOCUMENT_FILE_ERROR",
      value: "",
    });

    try {
      yield call(MiscApi.updateAdminDocumentFile, data.id, data.payload);

      yield put({
        type: "REQUEST_DOCUMENT_FILE_LIST",
        page: 0,
      });
      yield put({
        type: "HIDE_MODAL",
      });
      yield put({
        type: "CLEAR_DOCUMENT_FILE_FORM_STATE",
      });
      swal("Done", "Document updated successfully", "success");
    } catch (err) {
      const message = getErrorMessage(err);
      yield put({
        type: "SET_DOCUMENT_FILE_ERROR",
        value: message,
      });
    } finally {
      yield put({
        type: "SET_DOCUMENT_FILE_SUBMITTING",
        value: false,
      });
    }
  },
});
